import React from "react";
import { HiPrinter } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../../../../redux/features/ui/uiSlice";
import { getOutputFormats, getReportInfo, getReportData, getSN } from "../../../../../redux/selectors";
import print from "../../../../../services/print";
import { Dropdown, Button } from "react-bootstrap";
import { setError } from "../../../../../redux/features/modals/modalsSlice";
import ModalDownload from "../../edit master/browser/ModalDownload";
import { BsFiletypeDocx, BsFiletypeHtml, BsFiletypePdf, BsFiletypeTxt, BsFiletypeXls } from "react-icons/bs";

const PrintReport = ({ tabID }) => {
  const dispatch = useDispatch();
  const serialnumber = useSelector((state) => getSN(state));
  const outputFormats = useSelector((state) => getOutputFormats(state)?.list);

  const [printURL, setPrintURL] = React.useState(undefined);
  const [fileName, setFileName] = React.useState("");
  const [format, setFormat] = React.useState("");
  const [showModal, setShowModal] = React.useState(false);

  const reportInfo = useSelector((state) => getReportInfo(state, tabID));
  const reportData = useSelector((state) => getReportData(state, tabID));

  const handlePrintBrowser = async (format) => {
    dispatch(setLoading({ show: true, tabID }));
    const printDoc = await print({ reqID: reportInfo.reqID, format });
    if (printDoc.success) {
      setPrintURL(`https://${serialnumber}.oncloud.gr/s1services/?filename=${printDoc.filename}`);
      setFileName(printDoc.filename.replace(/[<>:"/\\|?*\x00-\x1F]/g, "_"));
      setFormat(format);
      setShowModal(true);
    } else {
      dispatch(setError({ show: true, message: printDoc.error }));
      console.log("error while printing:", printDoc);
    }
    dispatch(setLoading({ show: false, tabID }));
  };

  const PrintDropDown = React.forwardRef(({ children, onClick }, ref) => (
    <a
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
  ));

  const Ascii = (
    <div className="d-flex justify-content-start align-items-center">
      <BsFiletypeTxt className="me-2" /> Ascii
    </div>
  );

  const PDF = (
    <div className="d-flex justify-content-start align-items-center">
      <BsFiletypePdf className="me-2" /> PDF
    </div>
  );

  const HTML = (
    <div className="d-flex justify-content-start align-items-center">
      <BsFiletypeHtml className="me-2" /> HTML
    </div>
  );

  const Excel = (
    <div className="d-flex justify-content-start align-items-center">
      <BsFiletypeXls className="me-2" /> Excel
    </div>
  );

  const Word = (
    <div className="d-flex justify-content-start align-items-center">
      <BsFiletypeDocx className="me-2" /> Word
    </div>
  );

  return (
    <Dropdown className="d-flex" align="start">
      <Dropdown.Toggle as={PrintDropDown}>
        <Button variant="secondary">
          <HiPrinter />
        </Button>
      </Dropdown.Toggle>
      <Dropdown.Menu className="shadow">
        {Object.keys(outputFormats).map((key) => (
          <Dropdown.Item key={key} onClick={() => handlePrintBrowser(key)}>
            {{
              "Ascii file": Ascii,
              "PDF file": PDF,
              "Html image file": HTML,
              "Spreadsheet file": Excel,
              "Document file": Word,
            }[outputFormats[key]] ?? outputFormats[key]}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
      <ModalDownload
        show={showModal}
        setShow={setShowModal}
        url={printURL}
        fileName={fileName}
        format={format}
        tabID={tabID}
      />
    </Dropdown>
  );
};

export default PrintReport;
